module.exports = new __parcel__URL__("celebration.4590e486.svg").toString();